import React from "react";
import "./contact.css";
import phone from "./img/phone.gif";
import mail from "./img/mail.gif";
import location from "./img/location.gif";
function ContactComp() {
  function handleSubmit(e) {
    e.preventDefault();
    e.target.reset();
  }
  return (
    <>
      <br></br>
      <div className="contact_outer">
        <p>
          You've got some Questions and w've got tons and tons of Answers. Ask
          us about an order, a product, what you should name your puppy...
          anything we can help with! Don't be shy -we promise we're really nice.
        </p>
      </div>

      <div className="contactDetails">
        <div className="specific">
          <div>
            <img src={phone} alt="" />
          </div>
          <div>
            <h4>Contact</h4>
            <p>+91-9045880668</p>
          </div>
        </div>

        <div className="specific">
          <div>
            <img src={mail} alt="" />
          </div>
          <div>
            <h4>Write us</h4>
            <p>gshivam472@gmail.com</p>
          </div>
        </div>

        <div className="specific">
          <div>
            <img src={location} alt="" />
          </div>
          <div>
            <h4>We are at</h4>
            <p>Budaun, Uttar Pradesh</p>
          </div>
        </div>
      </div>

      <div className="google-map-container">
        <h2>Our Location</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3521.6291969888357!2d79.12810631152325!3d28.03580697589574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397545eb64a2a1b7%3A0xd4213cc3441e1246!2sShivam%20Beauty%20Collection!5e0!3m2!1sen!2sin!4v1731521339175!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Our Location"
        ></iframe>
      </div>
    </>
  );
}

export default ContactComp;
